import {
  mpBackend,
  TMPBackendError,
  TtransformedPromise,
} from '../../../../config/axios';
import { handleMpBackendError } from '../../../../config/error';
import { IReview } from '../p/components/page-sections/reviews/types';
import { TPriceDetails } from './pricingTypes';
import {
  transformDocuments,
  transformPlanDetails,
  transformReviews,
} from './transformer';
import { transformPriceDetails } from './transformerPricing';
import { TDocument, TPlanDetails } from './types';

export const getProductDetails = (
  productId: string
): TtransformedPromise<TPlanDetails> => {
  return mpBackend
    .get(`plan-details/${productId}`)
    .then((data) => transformPlanDetails(data))
    .catch((err: TMPBackendError) => {
      handleMpBackendError(err);
      console.log(`plan api failing for plan: ${productId}`);
    });
};

export const getPriceDetails = (
  planId: string,
  transformer?: (data: TPriceDetails) => void
): TtransformedPromise<TPriceDetails> => {
  return mpBackend
    .get(`price/plans_pricing?plan_id=${planId}`)
    .then((data) =>
      transformer ? transformer(data) : transformPriceDetails(data)
    )
    .catch((err: TMPBackendError) => {
      handleMpBackendError(err);
      return transformer
        ? transformer({} as TPriceDetails)
        : transformPriceDetails({} as Array<Partial<TPriceDetails>>);
    });
};

export const getDocuments = (
  productId: string
): TtransformedPromise<Array<TDocument>> => {
  return mpBackend
    .get(`plan/${productId}/document`)
    .then((data) => transformDocuments(data))
    .catch((err: TMPBackendError) => {
      handleMpBackendError(err);
      console.log('document api failing');
    });
};

export const getReviews = (
  productId: string
): TtransformedPromise<Array<IReview>> => {
  return mpBackend
    .get(`plan/${productId}/reviews`)
    .then((data) => transformReviews(data))
    .catch((err: TMPBackendError) => {
      handleMpBackendError(err);
    });
};

export const postReview = (
  productId: string,
  review: IReview
): Promise<string> => {
  return mpBackend
    .post(`plan/${productId}/reviews`, review)
    .then((data) => {
      return data;
    })
    .catch((err: TMPBackendError) => {
      handleMpBackendError(err);
    });
};
